























































import { Component, Prop, Vue } from 'vue-property-decorator'
import { QuestionBankCategoryTreeNode } from '@/modules/common/models/auto-paper'

@Component({
  name: 'QuestionBankCategoryTree'
})
export default class QuestionBankCategoryTree extends Vue {
  @Prop({default: () => []}) readonly categories!: Array<QuestionBankCategoryTreeNode>
  @Prop({default: () => []}) readonly selectedIds!: Array<number>
  @Prop({default: 0}) readonly level!: number

  formatCategoryName(name: string): string {
    const characters = Array.from(name)
    return characters.length > 22 ? `${characters.slice(0, 22).join('')}…` : name
  }

  isSelected(id: number): boolean {
    return this.selectedIds.indexOf(id) !== -1
  }

  toggleSelection(category: QuestionBankCategoryTreeNode) {
    this.$emit('toggle-select', {category, checked: !this.isSelected(category.id)})
  }

  hasMoreChildren(category: QuestionBankCategoryTreeNode): boolean {
    return category.childrenLoaded && (
      category.childCurrentPage < category.childLastPage || category.children.length < category.childTotal
    )
  }
}
